import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { lessonConst, useFinishLessonTest, useLessonTest } from 'modules/lesson-detail';

import { Skeleton } from './test/skeleton';
import Test from './test';

export const TestSection = () => {
  const t = useTranslations();
  const qc = useQueryClient();
  const { query } = useRouter();
  const { test, isLoading } = useLessonTest(query?.lesson as string);
  const { mutate, isLoading: isFinishing } = useFinishLessonTest(query?.lesson as string);

  const onFinish = async () => {
    await mutate(test?.ticket_id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    qc.invalidateQueries({ queryKey: [lessonConst.queryKeys.LESSONS_LIST, query?.course as string] });
  };

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <div className="my-5 space-y-3">
      <div className="flex items-center justify-between sm:px-4">
        <p className="font-semibold">{t('mavzuga_oid_testlar')}</p>
        <div className="flex items-center gap-2">
          <div className="rounded-md border border-gray-200 px-1.5 py-0.5 text-sm font-medium text-gray-500">
            {t('testlar_soni')} - {test?.test?.questions?.length}
          </div>
        </div>
      </div>
      {test?.test?.questions.map(item => <Test data={item} key={item.id} />)}
      <div className="flex items-center justify-center">
        <button
          disabled={isFinishing}
          onClick={onFinish}
          className="w-full max-w-40 cursor-pointer rounded-xl bg-green-500 px-5 py-3 text-center text-sm font-medium text-white hover:bg-green-600 disabled:cursor-not-allowed disabled:bg-green-300"
        >
          {isFinishing ? t('yakunlanmoqda') : t('testni_yakunlash')}
        </button>
      </div>
    </div>
  );
};
